import angular from 'angular';
import {BusinessHoursParamsController} from './business-hours-params.controller';
import {WeekDayEditionController} from './week-day-edition.controller';
import {ExceptionEditionController} from './exception-edition.controller';
import {BusinessHoursService} from './business-hours.service';
import {businessHours} from './business-hours.directive';


angular
  .module('parameters.business-hours', [])
  .controller('BusinessHoursParamsController', BusinessHoursParamsController)
  .controller('WeekDayEditionController', WeekDayEditionController)
  .controller('ExceptionEditionController', ExceptionEditionController)
  .factory('BusinessHoursFactory', BusinessHoursService.BusinessHoursFactory)
  .directive('businessHours', businessHours)
;
